export default __webpack_public_path__ + "static/media/udaf-logo.844b5868.svg";